<template>
    <form @submit.prevent="submitForm" id='AssignLocation'>

    <div class="mb-3">
      <label for="input-sku" class="form-label">
        Scan Waybil or Select Buy
      </label>
      <select v-model="transferToReceive" class="form-control" id="input-transfer-to-receive">
        <option v-for="(transferId, index) in transferToReceiveList" :value="transferId" :selected="0 == index">
          {{ transferId }}
        </option>
      </select>
    </div>

    <div class="mb-3">
      <label for="input-sku" class="form-label">
        Scan Location
      </label>
      <input type="text" v-model="sku" class="form-control" id="input-receive-sku" @keyup="validateSku">
    </div>
    <div class="row mb-3">
      <div class="col-6 offset-6 text-right">
        <button type="button" class="btn btn-primary btn-sm btn-clear-all" @click.prevent="clearAll" :disabled="!scannedSkus.length">
          Assign
        </button>
      </div>
    </div>
    <div class='row divider'>
        <div class='col-12'>
            <h3>Item Location</h3>
        </div>
    </div>
    <div class="card">
      <!--<div class="card-header">
        Item Location
      </div> -->
      <div class="card-body">
        <table class="table">
          <thead>
            <tr>
              <td>
                Waybill
              </td>
              <td>
                Old Location
              </td>
              <td>
                New Location
              </td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(sku, index) in scannedSkus">
              <td>
                {{ sku }}
              </td>
              <td>
                TODO: OLD BIN
              </td>
              <td>
                TODO: NEW BIN
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="d-grid gap-2 col-sm-6 mx-auto mt-4">
      <button type="submit" class="btn btn-success w-100 btn-finalize-receipt">
        Save and Close Session
      </button>
    </div>

  </form>

</template>

<script>
  export default {
    name: 'AssignLocation',
    data() {
      return {
        sku : '',
        transferToReceive : '',
        transferToReceiveList : [
          '21234234-23',// TODO: Temp
        ],
        destinationForTransfer : [],
        scannedSkus : [],
        selectedSkus : [],
      }
    },
    methods: {
      clearSelected() {
        this.selectedSkus.forEach(sku => this.removeSku(sku))
        this.selectedSkus.splice(0, this.selectedSkus.length)
      },
      clearAll() {
        this.selectedSkus.splice(0, this.selectedSkus.length)
        this.scannedSkus.splice(0, this.scannedSkus.length)
      },
      selectSku(sku) {
        if ( this.selectedSkus.includes(sku) ) {
          this.selectedSkus.splice(this.selectedSkus.indexOf(sku), 1)
        } else {
          this.selectedSkus.push(sku)
        }
      },
      removeSku(sku) {
        this.scannedSkus.splice(this.scannedSkus.indexOf(sku), 1)
      },
      addSku(sku) {
        if ( sku ) {
          if ( this.scannedSkus.indexOf(sku) == -1 ) { //TODO: not working
            this.scannedSkus.push(sku)
          }
        }
      },
      validateSku(e) {
        let enter = ( 'Enter' == e.key ? '' : '' )
        if ( 'Enter' == e.key ) {
          e.preventDefault()
          this.addSku(this.sku)
          this.sku = ''
        }
      },
      submitForm() {
        const {
          sku,
          transferToReceive,
          destinationForTransfer,
          scannedSkus
        } = this
        console.log('ReceiveTransfer', scannedSkus, transferToReceive, destinationForTransfer)
      }
    }
  }
</script>